import { createGtm } from '@gtm-support/vue-gtm'
import { defineNuxtPlugin, useRouter, useRuntimeConfig } from '#app'
import { useHead, useGtag } from '#imports'

export default defineNuxtPlugin({
    name: 'google-tag-manager',
    dependsOn: ['dayjs'],
    parallel: true,
    async setup(nuxtApp) {
        const config = useRuntimeConfig()

        if (config.public.gtm.id === 'GTM-XXXXXXXXXX') return

        const gtmOptions = {
            ...config.public.gtm,
            id: config.public.gtm.id,
            enabled: config.public.gtm.id !== 'GTM-XXXXXXXXXX',
            vueRouter: useRouter(),
        }
        const { initGtag } = useGtag()

        if (import.meta.server) {
            useHead({
                script: [
                    {
                        src: `${gtmOptions.source}?id=${gtmOptions.id}`,
                        async: true,
                        defer: true,
                        tagPosition: 'bodyClose',
                        tagPriority: 'low'
                    },
                ],
                noscript: [
                    {
                        innerHTML: `<iframe src="${gtmOptions.source}?id=${gtmOptions.id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
                        tagPosition: 'bodyClose',
                        tagPriority: 'low',
                    },
                ],
            })
        }

        if (import.meta.client) {
            initGtag()

            nuxtApp.vueApp.use(
                createGtm({
                    ...gtmOptions,
                }),
            )
        }
    }
})
